(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
  (() => {
    document.querySelectorAll('[data-gm-contact-widget]').forEach((widget) => {
      const panel = widget.querySelector('[data-gm-contact-panel]');
      const toggle = widget.querySelector('[data-gm-contact-toggle]');
      const close = widget.querySelector('[data-gm-contact-close]');
      const openButtons = document.querySelectorAll('[data-gm-contact-open]');
      if (!panel || !toggle || !close) return;

      const setOpen = (open) => {
        panel.hidden = !open;
        toggle.setAttribute('aria-expanded', String(open));
        if (open) close.focus();
      };

      toggle.addEventListener('click', () => setOpen(panel.hidden));
      close.addEventListener('click', () => {
        setOpen(false);
        toggle.focus();
      });
      openButtons.forEach((button) => button.addEventListener('click', () => setOpen(true)));
      document.addEventListener('keydown', (event) => {
        if (event.key === 'Escape' && !panel.hidden) {
          setOpen(false);
          toggle.focus();
        }
      });
      document.addEventListener('click', (event) => {
        const target = event.target;
        if (!(target instanceof Element)) return;
        if (!panel.hidden && !widget.contains(target) && !target.closest('[data-gm-contact-open]')) setOpen(false);
      });
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
